/*
 * 1DS JS SDK Properties plugin, 3.1.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* IntWeb.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
import { safeGetCookieMgr, objDefineAccessors, getCookieValue } from "@microsoft/1ds-core-js";
var IntWeb = /** @class */function () {
  function IntWeb(propertiesConfig, core) {
    this.core = core;
    if (propertiesConfig.serviceName) {
      this.serviceName = propertiesConfig.serviceName;
    }
    this._cookieMgr = safeGetCookieMgr(core);
  }
  /**
   * Anonymous visitor Id in hosting domain.
   */
  IntWeb.prototype.getMsfpc = function () {
    return getCookieValue(this._cookieMgr, "MSFPC");
  }; /**
     * ANON - MSA Anonymous ID.
     */
  IntWeb.prototype.getAnid = function () {
    return getCookieValue(this._cookieMgr, "ANON").slice(0, 34);
  };
  /**
   * Static constructor, attempt to create accessors
   */
  IntWeb._staticInit = function () {
    // Dynamically create get/set property accessors
    objDefineAccessors(IntWeb.prototype, "msfpc", IntWeb.prototype.getMsfpc);
    objDefineAccessors(IntWeb.prototype, "anid", IntWeb.prototype.getAnid);
  }();
  return IntWeb;
}();
export { IntWeb };